const apps = 'apps';
const longPollingTriggers = 'longPollingTriggers';
const longPollingExtraAction = 'longPollingExtraAction';
const argumentDependencies = 'argumentDependencies';
const actionOnCompletionHook = 'actionOnCompletionHook';
const installationLabel = 'installationLabel';

const suggestions = { apps, longPollingTriggers, longPollingExtraAction, argumentDependencies, actionOnCompletionHook, installationLabel };

export default suggestions;
